export enum OperatingSystem {
  Windows = 'Windows',
  Macintosh = 'Mac_OS',
  Android = 'Android',
  iPhone = 'iOS',
  Linux = 'Linux',
}
